import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const deliverables = [{
  title: 'eBook Maestro "Vender Sin Perseguir"',
  description: 'La hoja de ruta paso a paso de la mentalidad y el proceso.'
}, {
  title: 'Scripts Copy-Paste Ant-Ghosting',
  description: 'Los mensajes exactos para rescatar ventas muertas.'
}, {
  title: 'El Filtro IMÁN',
  description: 'Cómo identificar al cliente con el dinero y la urgencia en menos de 2 minutos.'
}, {
  title: 'Guía de Cierres de 3 Pasos',
  description: 'La estructura semántica para que el "Sí" sea la única opción lógica.'
}, {
  title: 'Protocolo 7+7+7',
  description: 'Un plan de acción de una semana para ver resultados reales en tus chats.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function WhatYouGet() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-181">
      <div className="max-w-4xl mx-auto" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-183">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 mb-4" data-id="element-184">
            Lo que obtienes hoy
          </h2>
          <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full" data-id="element-185" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-6" data-id="element-186">
          {deliverables.map((item, index) => <motion.div key={index} variants={itemVariants} className="flex items-start gap-4 p-6 bg-cream-50 rounded-xl border border-cream-100 hover:shadow-md transition-shadow duration-300" data-id="element-187">
              <div className="flex-shrink-0 mt-1" data-id="element-188">
                <CheckCircle2 className="w-6 h-6 text-gold-600" data-id="element-189" />
              </div>
              <div data-id="element-190">
                <h3 className="text-xl font-bold text-navy-900 mb-2 font-sans" data-id="element-191">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-192">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}